import React from "react";

export const ImageType = Object.freeze({
  Music: "Music",
  Routine: "Routine",
  Assistance: "Assistance",
  Favorites: "Favorites",
  Melodies: "Melodies",
  Play: "Play",
  Stop: "Stop",
  StopMini: "StopMini",
  SoundsAllowAll: "SoundsAllowAll",
  SoundsDenyAll: "SoundsDenyAll",
  OnlySoundsAndHours: "OnlySoundsAndHours",
  DialCorrection: "DialCorrection",
  MusicsSynth: "MusicsSynth",
  MusicsSynth_disabled: "MusicsSynth_disabled",
  CalendarEvent: "CalendarEvent",
});

const images = {
  [ImageType.Music]: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="61.309"
      height="100"
      viewBox="0 0 61.309 80.37"
    >
      <defs>
        <filter
          id="prefix__ic_queue_music_24px"
          width="61.309"
          height="80.37"
          x="0"
          y="0"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="3" />
          <feGaussianBlur result="blur" stdDeviation="4.5" />
          <feFlood floodOpacity=".051" />
          <feComposite in2="blur" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="prefix__ic_melodia">
        <path
          id="prefix__ic_queue_music_24px-2"
          d="M55.458 6v31.183a11.418 11.418 0 1 0 7.624 10.75V13.624h11.437V6z"
          data-name="ic_queue_music_24px"
          transform="translate(-26.71 4.5)"
          style={{ fill: "#114668" }}
        />
      </g>
    </svg>
  ),
  [ImageType.Routine]: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="76.371"
      height="100"
      viewBox="0 0 76.371 87.316"
    >
      <defs>
        <filter
          id="prefix__ic_repeat_24px"
          width="75.567"
          height="54.319"
          x=".804"
          y="0"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="3" />
          <feGaussianBlur result="blur" stdDeviation="4.5" />
          <feFlood floodOpacity=".051" />
          <feComposite in2="blur" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="prefix__ic_repeat_24px-2"
          width="75.567"
          height="54.319"
          x="0"
          y="32.997"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="3" />
          <feGaussianBlur result="blur-2" stdDeviation="4.5" />
          <feFlood floodOpacity=".051" />
          <feComposite in2="blur-2" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="prefix__ic_routine_2">
        <g transform="translate(13.5 10.5) translate(-13.5 -10.5)">
          <path
            id="prefix__ic_repeat_24px-3"
            d="M15.192 17.162h30.385v9.122l12.142-12.142L45.577 2v9.122H9.152v18.2h6.04z"
            className="prefix__cls-1"
            data-name="ic_repeat_24px"
            transform="translate(5.15 8.5)"
            style={{ fill: "#114668" }}
          />
        </g>
        <g transform="translate(13.5 10.5) translate(-13.5 -10.5)">
          <path
            id="prefix__ic_repeat_24px-4"
            d="M6.04 15.162h30.385v9.122l12.142-12.142L36.425 0v9.122H0v18.2h6.04z"
            className="prefix__cls-1"
            data-name="ic_repeat_24px"
            transform="rotate(180 31.035 35.41)"
            style={{ fill: "#114668" }}
          />
        </g>
      </g>
    </svg>
  ),
  [ImageType.Assistance]: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="79.188"
      height="100"
      viewBox="0 0 79.188 79.188"
    >
      <defs>
        <filter
          id="prefix__ic_perm_phone_msg_24px"
          width="53.094"
          height="55.993"
          x="26.094"
          y="0"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="3" />
          <feGaussianBlur result="blur" stdDeviation="4.5" />
          <feFlood floodOpacity=".051" />
          <feComposite in2="blur" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="prefix__ic_perm_phone_msg_24px-2"
          width="79.188"
          height="79.188"
          x="0"
          y="0"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="3" />
          <feGaussianBlur result="blur-2" stdDeviation="4.5" />
          <feFlood floodOpacity=".051" />
          <feComposite in2="blur-2" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="prefix__ic_assistenza">
        <g transform="translate(13.5 10.5) translate(-13.5 -10.5)">
          <path
            id="prefix__ic_perm_phone_msg_24px-3"
            d="M29.094 3v28.993l8.7-8.7h17.4V3z"
            data-name="ic_perm_phone_msg_24px"
            transform="translate(10.5 7.5)"
            style={{ fill: "#26659a" }}
          />
        </g>
        <g transform="translate(13.5 10.5) translate(-13.5 -10.5)">
          <path
            id="prefix__ic_perm_phone_msg_24px-4"
            d="M52.289 39.242a32.938 32.938 0 0 1-10.351-1.653 2.959 2.959 0 0 0-2.957.7L32.6 44.664a43.706 43.706 0 0 1-19.1-19.078l6.379-6.408a2.846 2.846 0 0 0 .721-2.928A32.938 32.938 0 0 1 18.946 5.9a2.908 2.908 0 0 0-2.9-2.9H5.9A2.908 2.908 0 0 0 3 5.9a49.285 49.285 0 0 0 49.289 49.288 2.908 2.908 0 0 0 2.9-2.9V42.141a2.908 2.908 0 0 0-2.9-2.899z"
            data-name="ic_perm_phone_msg_24px"
            transform="translate(10.5 7.5)"
            style={{ fill: "#114668" }}
          />
        </g>
      </g>
    </svg>
  ),
  [ImageType.Favorites]: (
    <svg width="60" height="100" viewBox="0 0 33.684 32">
      <path
        fill="#114668"
        d="M18.842 27.718L29.25 34l-2.762-11.84 9.2-7.966-12.114-1.028L18.842 2l-4.733 11.166L2 14.194l9.2 7.966L8.434 34z"
        transform="translate(-2 -2)"
      />
    </svg>
  ),
  [ImageType.Melodies]: (
    <svg width="60" height="100" viewBox="0 0 15.066 19.086">
      <path
        fill="#114668"
        d="M0 17.524v1.562h15.066v-5.623h-1.843v4.061H1.794v-4.061H0z"
      />
      <path
        fill="#114668"
        d="M15.066 1.562V0H0v5.623h1.843V1.562h11.429v4.061h1.794z"
      />
      <path
        fill="#114668"
        d="M.386 7.001v4.995h1.028v-3.5h.014l1.224 3.5h.846l1.224-3.54h.014v3.54h1.03V7.001H4.22l-1.106 3.435H3.1L1.932 7.001zM7.83 9.352v-1.5h.853a2.3 2.3 0 0 1 .364.028.847.847 0 0 1 .308.108.591.591 0 0 1 .213.227.8.8 0 0 1 .08.385.8.8 0 0 1-.08.385.591.591 0 0 1-.213.227.847.847 0 0 1-.308.108 2.3 2.3 0 0 1-.364.028zm-1.1-2.351v4.995h1.1v-1.791h1.154a2.08 2.08 0 0 0 .8-.136 1.492 1.492 0 0 0 .535-.36 1.379 1.379 0 0 0 .3-.514 1.9 1.9 0 0 0 .094-.591 1.889 1.889 0 0 0-.094-.595 1.384 1.384 0 0 0-.3-.511 1.492 1.492 0 0 0-.535-.36 2.08 2.08 0 0 0-.8-.136zm5.776 2.08v.7q.182 0 .381.01a1.157 1.157 0 0 1 .367.077.622.622 0 0 1 .276.213.712.712 0 0 1 .108.427.717.717 0 0 1-.231.563.82.82 0 0 1-.567.206.844.844 0 0 1-.374-.077.765.765 0 0 1-.262-.206.92.92 0 0 1-.161-.308 1.413 1.413 0 0 1-.063-.374h-.944a1.963 1.963 0 0 0 .122.756 1.535 1.535 0 0 0 .367.556 1.578 1.578 0 0 0 .577.346 2.261 2.261 0 0 0 .752.119 2.241 2.241 0 0 0 .686-.1 1.777 1.777 0 0 0 .581-.308 1.5 1.5 0 0 0 .4-.5 1.513 1.513 0 0 0 .15-.686 1.149 1.149 0 0 0-.231-.721 1.066 1.066 0 0 0-.637-.392v-.014a.86.86 0 0 0 .514-.371 1.159 1.159 0 0 0 .171-.63 1.131 1.131 0 0 0-.147-.581 1.42 1.42 0 0 0-.381-.427 1.673 1.673 0 0 0-.528-.262 2.051 2.051 0 0 0-.588-.087 1.84 1.84 0 0 0-.686.122 1.518 1.518 0 0 0-.528.346 1.574 1.574 0 0 0-.343.535 2.081 2.081 0 0 0-.136.689h.955a.962.962 0 0 1 .185-.626.677.677 0 0 1 .57-.248.751.751 0 0 1 .483.168.582.582 0 0 1 .21.483.52.52 0 0 1-.1.336.651.651 0 0 1-.259.192 1.079 1.079 0 0 1-.339.08 2.1 2.1 0 0 1-.35-.006z"
      />
    </svg>
  ),
  [ImageType.Play]: (
    <svg width="38.014" height="80" viewBox="0 0 38.014 48.381">
      <path
        d="M8 5v48.381L46.014 29.19z"
        transform="translate(-8 -5)"
        style={{ fill: "#fff" }}
      />
    </svg>
  ),
  [ImageType.Stop]: (
    <svg width="44.383" height="80" viewBox="0 0 44.383 44.383">
      <path
        fill="#fff"
        d="M6 6h44.383v44.383H6z"
        transform="translate(-6 -6)"
      />
    </svg>
  ),
  [ImageType.StopMini]: (
    <svg width="22" height="22" viewBox="0 0 22 22">
      <path fill="#114668" d="M6 6h22v22H6z" transform="translate(-6 -6)" />
    </svg>
  ),
  [ImageType.SoundsAllowAll]: (
    <svg width="50" height="100" viewBox="0 0 13.263 17.227">
      <path
        fill="#114668"
        d="M-413.79 340.164a1.035 1.035 0 0 0 1.015-.849h-2.067s0 .849 1.052.849z"
        transform="translate(420.44 -325.151)"
      />
      <path
        fill="#114668"
        d="M-421.174 306.474h-.034c-6.54 0-6.615 3.914-6.615 4.081V323.7h13.263v-13.154c-.001-.167-.117-4.072-6.614-4.072zm-.034 1.725h.034c3.618 0 4.559 1.347 4.8 2h-9.643c.246-.664 1.181-1.999 4.81-1.999zm-4.889 13.776v-10.31h4.549v.565s-1.983.165-1.983 1.625-.633 3.835-1.211 4.275a2.967 2.967 0 0 0-.771 1.569s1.046.633 4.323.633 4.323-.633 4.323-.633a2.966 2.966 0 0 0-.771-1.569c-.578-.44-1.212-2.816-1.212-4.275s-1.982-1.625-1.982-1.625v-.565h4.548v10.31z"
        transform="translate(427.822 -306.474)"
      />
    </svg>
  ),
  [ImageType.SoundsDenyAll]: (
    <svg width="65" height="100" viewBox="0 0 18.208 18.185">
      <g>
        <g>
          <g>
            <path
              fill="#114668"
              d="M-480.831 322.175l-16.924-16.924-1.261 1.261 2.276 2.276a3.131 3.131 0 0 0-.238 1.072v13.146h13.263v-1.193l1.623 1.623 1.284-1.285zm-4.609-.895h-9.813v-10.31h.7l1.9 1.9a1.449 1.449 0 0 0-.03.289c0 1.459-.634 3.834-1.211 4.275a2.965 2.965 0 0 0-.771 1.569s1.046.634 4.323.634a12.348 12.348 0 0 0 3.973-.484l.934.934z"
              transform="translate(499.015 -305.251) translate(-499.015 305.251) translate(0) translate(499.015 -305.251)"
            />
            <path
              fill="#114668"
              d="M-486.173 308.443a9.943 9.943 0 0 1 2.326-.244h.034c3.618 0 4.559 1.347 4.8 2h-5.4l1.462 1.462h4.026v4.026l1.725 1.725v-6.872c0-.167-.117-4.072-6.615-4.072h-.034a10.324 10.324 0 0 0-3.711.584z"
              transform="translate(499.015 -305.251) translate(-499.015 305.251) translate(0) translate(492.499 -305.947)"
            />
          </g>
          <path
            fill="#114668"
            d="M-480.258 340.164a1.035 1.035 0 0 0 1.015-.849h-2.067s0 .849 1.052.849z"
            transform="translate(499.015 -305.251) translate(-499.015 305.251) translate(488.946 -324.624)"
          />
        </g>
      </g>
    </svg>
  ),
  [ImageType.OnlySoundsAndHours]: (
    <svg width="65" height="100" viewBox="0 0 19.213 19.622">
      <g>
        <g>
          <g>
            <path
              fill="#114668"
              d="M-480.831 322.175l-16.924-16.924-1.261 1.261 2.276 2.276a3.131 3.131 0 0 0-.238 1.072v13.146h13.263v-1.193l1.623 1.623 1.284-1.285zm-4.609-.895h-9.813v-10.31h.7l1.9 1.9a1.449 1.449 0 0 0-.03.289c0 1.459-.634 3.834-1.211 4.275a2.965 2.965 0 0 0-.771 1.569s1.046.634 4.323.634a12.348 12.348 0 0 0 3.973-.484l.934.934z"
              transform="translate(499.015 -303.813) translate(-499.015 305.251) translate(0) translate(499.015 -305.251)"
            />
          </g>
          <path
            fill="#114668"
            d="M-480.258 340.164a1.035 1.035 0 0 0 1.015-.849h-2.067s0 .849 1.052.849z"
            transform="translate(499.015 -303.813) translate(-499.015 305.251) translate(488.946 -324.624)"
          />
        </g>
      </g>
      <path
        fill="#114668"
        d="M16993.205 14708.49a5.926 5.926 0 1 0-7.828-8.139l-1.217-1.265a7.62 7.62 0 1 1 10.264 10.67zm-3.457-4.473v-5.078h1.268v4.442l3.387 2-.635 1.041z"
        transform="translate(-16979 -14695.552)"
      />
    </svg>
  ),
  [ImageType.DialCorrection]: (
    <svg
      width="70"
      height="70"
      viewBox="0 0 45 45"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="#8ba5b5"
        d="M 23.734 9.983 L 19.987 9.983 L 19.987 24.955 L 31.855 32.068 L 33.734 28.999 L 23.74 23.084 L 23.734 9.983 Z M 22.489 0 C 5.177 0 -5.643 18.72 3.013 33.696 C 11.669 48.673 33.309 48.673 41.966 33.696 C 43.939 30.28 44.979 26.407 44.979 22.464 C 44.979 10.057 34.91 0 22.489 0 Z M 22.489 39.929 C 9.026 39.932 0.609 25.376 7.337 13.729 C 14.066 2.081 30.895 2.077 37.629 13.722 C 39.166 16.38 39.975 19.395 39.974 22.464 C 39.978 32.111 32.148 39.933 22.489 39.929 Z"
      />
    </svg>
  ),
  [ImageType.MusicsSynth]: (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width="80"
      height="100"
      viewBox="0 0 80 80"
      preserveAspectRatio="xMidYMid meet"
    >
      <g transform="translate(0.000000,80.000000) scale(0.100000,-0.100000)">
        <path
          fill="#114668"
          d="M80 400 l0 -320 320 0 320 0 0 320 0 320 -320 0 -320 0 0 -320z m560 0 l0 -240 -240 0 -240 0 0 240 0 240 240 0 240 0 0 -240z"
        />
        <path
          fill="#114668"
          d="M270 521 c0 -25 -5 -30 -36 -35 -32 -7 -35 -10 -32 -39 2 -27 8 -33 33 -37 l30 -5 3 -93 3 -92 34 0 35 0 0 94 0 95 33 3 c28 3 32 6 32 33 0 25 -5 32 -32 40 -27 7 -33 14 -33 37 0 25 -3 28 -35 28 -32 0 -35 -3 -35 -29z"
        />
        <path
          fill="#114668"
          d="M450 440 l0 -110 -30 0 c-24 0 -31 -5 -36 -27 -8 -29 14 -53 48 -53 10 0 18 -7 18 -15 0 -11 11 -15 40 -15 26 0 40 5 40 13 0 7 15 17 32 22 53 16 46 75 -8 75 -24 0 -24 1 -24 110 l0 110 -40 0 -40 0 0 -110z"
        />
      </g>
    </svg>
  ),
  [ImageType.MusicsSynth_disabled]: (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width="80"
      height="80"
      opacity="0.6"
      viewBox="0 0 80 80"
      preserveAspectRatio="xMidYMid meet"
    >
      <g transform="translate(0.000000,80.000000) scale(0.100000,-0.100000)">
        <path
          fill="#114668"
          d="M80 400 l0 -320 320 0 320 0 0 320 0 320 -320 0 -320 0 0 -320z m560 0 l0 -240 -240 0 -240 0 0 240 0 240 240 0 240 0 0 -240z"
        />
        <path
          fill="#114668"
          d="M270 521 c0 -25 -5 -30 -36 -35 -32 -7 -35 -10 -32 -39 2 -27 8 -33 33 -37 l30 -5 3 -93 3 -92 34 0 35 0 0 94 0 95 33 3 c28 3 32 6 32 33 0 25 -5 32 -32 40 -27 7 -33 14 -33 37 0 25 -3 28 -35 28 -32 0 -35 -3 -35 -29z"
        />
        <path
          fill="#114668"
          d="M450 440 l0 -110 -30 0 c-24 0 -31 -5 -36 -27 -8 -29 14 -53 48 -53 10 0 18 -7 18 -15 0 -11 11 -15 40 -15 26 0 40 5 40 13 0 7 15 17 32 22 53 16 46 75 -8 75 -24 0 -24 1 -24 110 l0 110 -40 0 -40 0 0 -110z"
        />
      </g>
    </svg>
  ),
  [ImageType.CalendarEvent]: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="70"
      height="100"
      viewBox="0 0 119.4 130.667"
    >
      <defs>
        <filter
          id="prefix__ic_event_24px"
          width="119.4"
          height="130.667"
          x="0"
          y="0"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="3" />
          <feGaussianBlur result="blur" stdDeviation="3" />
          <feFlood flood-opacity=".161" />
          <feComposite in2="blur" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="prefix__ic_event_24px-2"
          width="39.634"
          height="39.634"
          x="61.033"
          y="71.699"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="3" />
          <feGaussianBlur result="blur-2" stdDeviation="3" />
          <feFlood flood-opacity=".161" />
          <feComposite in2="blur-2" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="prefix__ic_calendario">
        <g transform="translate(9 6) translate(-9 -6)">
          <path
            id="prefix__ic_event_24px-3"
            d="M76.233 1v11.267H31.167V1H19.9v11.267h-5.633A11.216 11.216 0 0 0 3.056 23.533L3 102.4a11.264 11.264 0 0 0 11.267 11.267h78.866A11.3 11.3 0 0 0 104.4 102.4V23.533a11.3 11.3 0 0 0-11.267-11.266H87.5V1zm16.9 101.4H14.267V40.433h78.866z"
            data-name="ic_event_24px"
            transform="translate(6 5)"
            style={{ fill: "#114668" }}
          />
        </g>
        <g transform="translate(9 6) translate(-9 -6)">
          <path
            id="prefix__ic_event_24px-4"
            d="M54.634 37.667H33V59.3h21.634z"
            data-name="ic_event_24px"
            transform="translate(37.03 40.03)"
            style={{ fill: "#26659a" }}
          />
        </g>
      </g>
    </svg>
  ),
};

export const SvgImage = ({ type }) => (images[type] ? images[type] : null);
